import { render, staticRenderFns } from "./DuplicateLog.vue?vue&type=template&id=16955246&"
import script from "./DuplicateLog.vue?vue&type=script&lang=js&"
export * from "./DuplicateLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports